export const designActionWithoutMofidyTextOfButtonText = {
  name: 'design',
  groupLayout: 'topBottom',
  config: {
    文字设计: [
      'self_textTheme',
      'self_fontFamily',
      'self_fontSize',
      'self_color',
      'self_textStyle',
      'self_textAlign',
      'self_upperLowerCase'
    ],
    按钮设计: [
      'self_background',
      'self_border',
      //'self_margin',
      'self_marginNotAuto',
      'self_padding',
      //'self_transverseMargin',
      'self_borderRadius',
      'self_shadow',
      'icon_color',
      'icon_fontSize',
      'self_width'
    ]
  }
}

export const designActionWithoutHOfTitle = {
  name: 'design',
  groupLayout: 'topBottom',
  config: {
    文字设计: [
      'self_background',
      'title_fontFamily',
      'title_fontSize',
      'title_color',
      'title_textStyle',
      'title_textAlign',
      'title_lineHeight',
      'title_letterSpace',
      'self_margin',
      'self_padding'
    ]
  }
}

export const designActionWithoutHOfParagraph = {
  name: 'design',
  groupLayout: 'topBottom',
  config: {
    文字设计: [
      'self_upperLowerCase',
      'self_background',
      'title_textTheme',
      'title_fontFamily',
      'title_fontSize',
      'title_color',
      'title_textStyle',
      'title_textAlign',
      'title_lineHeight',
      'title_letterSpace',
      'self_margin',
      'self_padding',
      'title_textOverflow'
    ]
  }
}

export const cardActions = [
  {
    name: 'design',
    groupLayout: 'topBottom',
    config: {
      文字设计: ['1','2','3',  '4', 'self_borderRadius'/*, 'self_shadow'*/]
    }
  },
  {
    name: 'hover',
    groupLayout: 'topBottom',
    config: {
      文字设计: ['5', /*'7',*/'6']
    }
  }
]

export const svgActions = ['design']
